import { useEffect, useRef } from 'react'

const useCreatePreview = ({
  backgroundColor,
  textColor,
  linkColor,
  loadScriptContainerId,
  widgetContainerId,
  customTexts,
  language,
}) => {
  const updateTimeOut = useRef()

  useEffect(() => {
    if (!backgroundColor || !textColor) return

    if (updateTimeOut.current) {
      clearTimeout(updateTimeOut.current)
    }

    updateTimeOut.current = setTimeout(() => {
      const script = document.createElement('script')
      script.defer = true
      const configurationObject = {
        text_color: textColor,
        background_color: backgroundColor,
        link_color: linkColor || 'red',
        custom_texts: customTexts,
        size_guide_url: customTexts?.size_guide_url,
      }

      const params = new URLSearchParams()

      params.append('configuration', encodeURIComponent(JSON.stringify(configurationObject)))
      params.append('language', language)
      params.append('products', encodeURIComponent(JSON.stringify([{ product_id: 1 }, { product_id: 2 }])))

      script.src = `${import.meta.env.VITE_REVENI_BRACKETING_WIDGET}?${params.toString()}`

      const container = document.getElementById(loadScriptContainerId)
      container.innerHTML = ''

      document.getElementById(widgetContainerId)?.remove()

      const sizingWidgetContainer = document.createElement('div')
      sizingWidgetContainer.id = widgetContainerId
      sizingWidgetContainer.dataset.products = JSON.stringify([{ product_id: 1 }, { product_id: 1 }])
      container.parentNode.appendChild(sizingWidgetContainer)

      container.appendChild(script)

      return () => {
        container.innerHTML = ''
        document.getElementById(widgetContainerId)?.remove()
      }
    }, 500)
  }, [textColor, backgroundColor, loadScriptContainerId, widgetContainerId, language, linkColor, customTexts])
}

export default useCreatePreview
